import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const OR = () => {
  return (
    <CardSection id="OR" title="OR">
      <Paragraph>
        표현식 내에서 하나 이상의 값이 참인지 확인합니다. 조건에 부합할 경우{" "}
        <b>TRUE</b> 값이 반환됩니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>OR(ARGUMENT_1, [ARGUMENT_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT_1</b>은 평가하려는 첫 번째 인수입니다.
          </Li>
          <Li>
            <b>ARGUMENT_2, ... [선택사항]</b>은 추가 인수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>OR(`subject` == "math", score &gt; 70)</Paragraph>
        <Img src="computeOr" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>ARGUMENT</b>는 <b>TRUE</b> 또는 <b>FALSE</b> 값, 두 값 중
          하나를 포함하는 열 또는 두 값 중 하나를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>OR</b> 함수는 대소문자를 구분하지 않으므로 True, TRUE, true를
          동일한 방식으로 처리합니다. 마찬가지로 False, FALSE, false도 동일하게
          처리됩니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
